import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

const Item = ({
                article,
                src_desktop,
                src_iPad,
                disabled,
              }) => (

  <div
    className={classnames(styles.item, {
      [styles.disabled]: disabled,
    })}
  >
    <img src={src_desktop} alt="alt-desktop"/>
    <img src={src_iPad} alt="alt-iPad"/>
    <div className={styles.label}>{article}</div>
  </div>
);

export default Item;